<template>
    <CDropdown>
        <CDropdownToggle
            :color="color"
            :caret="caret"
            class="d-dropdown-toggle"
        >
            <DIcon
                v-if="icon"
                :size="20"
                :name="icon"
            />
            {{ togglerText }}
        </CDropdownToggle>
        <CDropdownMenu>
            <slot />
        </CDropdownMenu>
    </CDropdown>
</template>

<script>
import { CDropdown, CDropdownToggle, CDropdownMenu } from '@coreui/vue-pro'

export default {
    name: 'DRow',
    components: { CDropdownToggle, CDropdown, CDropdownMenu },
    props: {
        togglerText: {
            type: String,
            default: null
        },
        color: {
            type: String,
            default: 'secondary'
        },
        icon: {
            type: String,
            default: null
        },
        caret: {
            type: Boolean,
            default: true
        }
    }
}
</script>

<style>
.dropdown-toggle {
    box-shadow: none !important;
}

.d-dropdown-toggle {
    border-radius: 0.375rem !important;
}
</style>
